<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form class="form" autocomplete="off" @submit.prevent="handleSubmit(onSubmit)">
        <div class="container px-0">
          <div class="row">
            <!-- Học viên cần gia sư -->
            <div class="col-md-6 mb-3">
              <label>Học viên cần gia sư <span class="text-danger">*</span></label>
              <ValidationProvider name="Học viên" rules="required" v-slot="{ errors }">
                <el-select
                    v-model="form.studentId"
                    placeholder="Tìm tên, SĐT, mã học viên"
                    class="w-100"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="searchStudent"
                    :loading="loadingStudents"
                    clearable
                >
                  <el-option
                      v-for="s in students"
                      :key="s.id"
                      :label="studentLabel(s)"
                      :value="s.id"
                  />
                </el-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <!-- Nội dung gia sư -->
            <div class="col-md-6 mb-3">
              <label>Nội dung gia sư <span class="text-danger">*</span></label>
              <ValidationProvider name="Nội dung gia sư" rules="required|max:99" v-slot="{ errors }">
                <el-input
                    v-model="form.content"
                    placeholder="Nhập nội dung gia sư"
                    clearable
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <!-- Ngân sách phòng ban -->
            <div class="col-md-6 mb-3">
              <label>Ngân sách phòng ban </label>
              <ValidationProvider name="Ngân sách"  v-slot="{ errors }">
                <el-select
                    v-model="form.budgetId"
                    placeholder="Ngân sách phòng ban"
                    class="w-100"
                    filterable
                    clearable
                >
                  <el-option
                      v-for="b in budgets"
                      :key="b.id"
                      :label="b.name"
                      :value="b.id"
                  />
                </el-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <!-- Thời lượng gia sư -->
            <div class="col-md-6 mb-3">
              <label>Thời lượng gia sư <span class="text-danger">*</span></label>
              <ValidationProvider name="Thời lượng" rules="required" v-slot="{ errors }">
                <el-select
                    v-model="form.duration"
                    placeholder="Chọn thời lượng gia sư"
                    class="w-100"
                    @change="clearHour"
                >
                  <el-option v-for="d in durations" :key="d.value" :label="d.label" :value="d.value"/>
                </el-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <!-- Ngày học -->
            <div class="col-md-6 mb-3">
              <label>Ngày học <span class="text-danger">*</span></label>
              <ValidationProvider name="Ngày học" rules="required" v-slot="{ errors }">
                <el-date-picker
                    v-model="form.date"
                    type="date"
                    placeholder="Chọn ngày"
                    class="w-100"
                    format="dd-MM-yyyy"
                    value-format="yyyy-MM-dd"
                    :picker-options="{ disabledDate: d => d.getTime() < Date.now()-86400000 }"
                    @change="clearHour"

                />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <!-- Giờ học -->
            <div class="col-md-6 mb-3">
              <label>Giờ học <span class="text-danger">*</span></label>
              <ValidationProvider name="Giờ học" rules="required" v-slot="{ errors }">
                <el-select
                    v-model="form.time"
                    placeholder="Chọn giờ học"
                    class="w-100"
                    clearable
                    filterable
                    :disabled="!form.date || !form.duration"
                    :loading="loadingSlot"
                    @focus="getSlot()"
                >
                  <el-option-group
                      v-for="group in timeSlots"
                      :key="group.code"
                      :label="group.name">
                    <el-option
                        v-for="item in group.slots"
                        :key="item.start"
                        :label="item.start"
                        :value="item.start"
                        :disabled="item.disable"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <el-button @click="closeModal(false)">Trở lại</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting" :disabled="submitting" @click="onSubmit">
            Đặt lịch
          </el-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {GET_USER_BY_PHONE} from '@/core/services/store/user/users.module'
import {CREATE_SPECIAL_TUTOR, GET_SLOT, GET_STUDENT_OF_TUTOR} from "@/core/services/store/tutor/tutor.module";
// import { CREATE_TUTOR_BOOKING } from '@/core/services/store/tutor/tutor.module'
import moment from 'moment-timezone';


export default {
  name: 'SpecialTutor',
  props: {
    visible: {type: Boolean, default: true} // bạn tự điều khiển ẩn/hiện
  },
  data() {
    return {
      submitting: false,
      loadingStudents: false,
      students: [],
      budgets: [
        {id: 1, name: 'Sản phẩm ngoại ngữ'},
        {id: 2, name: 'Call Center'},
        {id: 3, name: 'Quản lý học viên'},
        {id: 4, name: 'Kinh doanh'},
        {id: 5, name: 'Dịch vụ'}
      ],
      durations: [
        {value: 60, label: '1h'},
        {value: 90, label: '1,5h'},
      ],
      timeSlots: [],
      form: {
        category: 'special',
        studentId: '',
        content: '',
        budgetId: '',
        duration: '',
        date: '',
        time: ''
      },
      loadingSlot:false
    }
  },
  methods: {
    studentLabel(s) {
      return `${s.name || 'Không rõ'} - ${s.phone || ''} ${s.code ? ' - ' + s.code : ''}`
    },
    async searchStudent(q) {
      if (!q) {
        this.students = []
        return
      }
      try {
        this.loadingStudents = true
        const res = await this.$store.dispatch(GET_STUDENT_OF_TUTOR, { keyword: q })
        this.students = res?.data || []
      } catch (e) {
        this.students = []
      } finally {
        this.loadingStudents = false
      }
    },
    async onSubmit() {
      const payload = {
        user_id: this.form.studentId,
        content: this.form.content,
        budget_amount_department_id: this.form.budgetId,
        duration_minutes: this.form.duration,
        date: this.form.date,
        time: this.form.time
      }
      try {
        this.submitting = true
        await this.$store.dispatch(CREATE_SPECIAL_TUTOR,payload)

        this.$message.success('Đặt lịch gia sư thành công')
        this.closeModal(true)
      } catch (e) {
        this.$message.error(e?.data?.message || 'Có lỗi xảy ra')
      } finally {
        this.submitting = false
      }
    },
    closeForm() {
      this.$emit('closeModal')
    },
    async getSlot() {
      this.timeSlots = []
      this.loadingSlot = true
      let payload = {
        subtype: 1,
        day: this.form.date,
        duration: this.form.duration
      }
     const data = await this.$store.dispatch(GET_SLOT, payload)
      if (data?.data?.slots.length) {
        const now = Date.now();

        [
          { code: 'morning', name: 'Buổi sáng' },
          { code: 'afternoon', name: 'Buổi chiều' },
          { code: 'evening', name: 'Buổi tối' }
        ].forEach(shift => {
          this.timeSlots.push({
            code: shift.code,
            name: shift.name,
            slots: data.data.slots
                .filter(s => s.code === shift.code)
                .map(slot => ({
                  ...slot,
                  start: this.formatTime(slot.start),
                  disable: new Date(slot.start).getTime() < now // thêm field disable
                }))
          });
        });
      }
      this.loadingSlot = false
    },
    clearHour(){
      this.form.time = ''
    },
    formatTime(isoString, timezone = 'Asia/Ho_Chi_Minh') {
      return moment.tz(isoString, timezone).format('HH:mm:ss');
    },
    closeModal(isCreateSuccessful = false){
      this.$emit('closeModal',isCreateSuccessful)
    }
  }
}
</script>

<style scoped>
.tutor-booking-card {
  max-width: 900px;
  margin: 0 auto;
}
</style>
